import React from 'react';
import cx from 'classnames';

export type TomPilula = 'acao' | 'sucesso' | 'info' | 'alerta' | 'novas';

type Props = {
  tom: TomPilula;
  children: React.ReactNode;
};

/** Pílula de status do item ("Requer sua ação") e a contagem "2 novas". */
const StatusPill = ({ tom, children }: Props) => (
  <span
    className={cx(
      'mpf-notificacoes__painel-pilula',
      `mpf-notificacoes__painel-pilula--${tom}`,
    )}
  >
    {children}
  </span>
);

export default StatusPill;
